// extracted by mini-css-extract-plugin
export default {"profilebody":"profile_profilebody__psmpS","profilemargin":"profile_profilemargin__HgbY0"};